import templateBase from './templates/category-pager-toolbox-base.view.html';
import template_t1 from './templates/category-pager-toolbox-t1.view.html';

function MenuDirective(SessionService) {

  let response = SessionService.get('components');
  let htmlTemplate = templateBase;


  return {
    restrict: 'E',
    template: htmlTemplate,
  };
}

MenuDirective.$inject = ['SessionService'];

export default MenuDirective;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.directive.js
 **/